import React, { useState } from "react";
import { Grid, Button } from "@mui/material";
import { useAppContext } from "../contexts/AppContextProvider";
import { CustomTextField } from "./index";

const EditPlatFormFee = ({ platFormFeeData, onClose }) => {
  const { savePlatformFee, getPlatformFeeData } = useAppContext();
  const now = new Date();
  const localDateTime = new Date(
    now.getTime() - now.getTimezoneOffset() * 60000,
  )
    .toISOString()
    .slice(0, 16);

  const [formData, setFormData] = useState({
    coinsCost: platFormFeeData?.coins_cost || 0,
    priceWef: localDateTime,
  });

  const [error, setError] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (Number(formData.coinsCost) < 4) {
      setError("Coins Cost must be at least 4");
      return;
    }
    const payload = {
      platformFeeId: platFormFeeData.id,
      channelName: platFormFeeData.channel_name,
      userChannelId: platFormFeeData.user_channel_id,
      countryCode: platFormFeeData.country_code,
      countryCodeIso3: platFormFeeData.country_code_iso3,
      entityType: platFormFeeData.entity_type,
      coinsCost: formData.coinsCost,
      priceWef: new Date().toISOString(),
      userId: platFormFeeData.user_id,
      remarks: platFormFeeData.remarks,
      isIncludeChannelPricing: platFormFeeData.is_include_channel_pricing,
    };

    savePlatformFee(payload);
    getPlatformFeeData(platFormFeeData?.user_id);
    onClose();
  };

  return (
    <form onSubmit={handleSubmit} className="p-6">
      <h2 className="mb-4 text-center">Edit PlatForm fee</h2>
      <div className="grid grid-cols-3 gap-4 py-2">
        <div>
          <p className="text-sm text-gray-600">Channel Name</p>
          <p className="font-medium">{platFormFeeData?.channel_name || "-"}</p>
        </div>

        <div>
          <p className="text-sm text-gray-600">Country Code</p>
          <p className="font-medium">{platFormFeeData?.country_code || "-"}</p>
        </div>

        <div>
          <p className="text-sm text-gray-600">Country ISO3</p>
          <p className="font-medium">
            {platFormFeeData?.country_code_iso3 || "-"}
          </p>
        </div>

        <div>
          <p className="text-sm text-gray-600">Entity Type</p>
          <p className="font-medium capitalize">
            {platFormFeeData?.entity_type || "-"}
          </p>
        </div>
        <div>
          <p className="text-sm text-gray-600">Currency</p>
          <p className="font-medium capitalize">
            {platFormFeeData?.currency || "-"}
          </p>
        </div>

        <CustomTextField
          fullWidth
          type="datetime-local"
          label="Price WEF"
          name="priceWef"
          value={formData.priceWef}
          onChange={handleChange}
          disabled
          InputLabelProps={{ shrink: true }}
        />
      </div>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <CustomTextField
            fullWidth
            type="number"
            label="Coins Cost"
            name="coinsCost"
            value={formData.coinsCost}
            onChange={handleChange}
          />
          {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
        </Grid>

        <Grid item xs={12}>
          <div className="flex justify-end gap-3">
            <Button
              variant="outlined"
              color="error"
              type="button"
              onClick={onClose}
            >
              Cancel
            </Button>
            <Button variant="contained" type="submit">
              Save
            </Button>
          </div>
        </Grid>
      </Grid>
    </form>
  );
};

export default EditPlatFormFee;
